import { api as captionThisApi } from './auto-generated/captionThis'

captionThisApi.enhanceEndpoints({
  endpoints: {},
})

export { captionThisApi }
